var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBautechniker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 85.1 56.3",
    style: {
      enableBackground: "new 0 0 85.1 56.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M46.8,21.2h-8.6c-0.4,0-0.8-0.2-1.1-0.5c-0.3-0.3-0.4-0.7-0.4-1.1l1.5-18.2C38.3,0.6,39,0,39.7,0h5.6 c0.8,0,1.4,0.6,1.5,1.4l1.5,18.2c0,0.4-0.1,0.8-0.4,1.1S47.3,21.2,46.8,21.2z M39.9,18.2h5.3L44,3h-2.8L39.9,18.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M79.9,50.9H5.2c-0.8,0-1.5-0.7-1.5-1.5c0-5.1,0.8-10,2.5-14.7c3.6-10.4,11-18.9,20.4-23.5l0.8-4.5 c0.1-0.4,0.3-0.8,0.7-1c0.2-0.1,4.5-2.6,11.2-3.2c0.4,0,0.9,0.1,1.2,0.4C40.9,3.2,41.1,3.6,41,4l-1.2,14.1h5.3L44.1,4.1 c0-0.4,0.1-0.9,0.4-1.2c0.3-0.3,0.8-0.5,1.2-0.4c3.8,0.4,7.5,1.4,11.1,3.1c0.5,0.2,0.8,0.6,0.9,1.1l0.7,4.5 c2.7,1.3,5.3,2.9,7.6,4.8c9.7,7.9,15.4,20.4,15.4,33.4C81.4,50.2,80.7,50.9,79.9,50.9z M6.8,47.9h71.6 C77.9,36.3,72.6,25.3,64,18.3c-2.3-1.9-4.9-3.5-7.7-4.7c-0.5-0.2-0.8-0.6-0.9-1.1L54.8,8c-2.5-1.1-5-1.8-7.6-2.3l1.1,13.8 c0,0.4-0.1,0.8-0.4,1.1c-0.3,0.3-0.7,0.5-1.1,0.5h-8.6c-0.4,0-0.8-0.2-1.1-0.5c-0.3-0.3-0.4-0.7-0.4-1.1l1.1-13.9 c-3.8,0.6-6.5,1.7-7.6,2.3l-0.8,4.6c-0.1,0.5-0.4,0.9-0.9,1.1c-9,4.1-16.1,12.2-19.6,22.1C7.7,39.6,6.9,43.7,6.8,47.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M59,26.9c-0.7,0-1.4-0.5-1.5-1.3L54.7,7.2c-0.1-0.8,0.4-1.6,1.3-1.7c0.8-0.1,1.6,0.4,1.7,1.3l2.9,18.4 c0.1,0.8-0.4,1.6-1.3,1.7C59.2,26.9,59.1,26.9,59,26.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25.6,26.9c-0.1,0-0.2,0-0.3,0c-0.8-0.1-1.4-0.9-1.2-1.7l3.3-18.4c0.1-0.8,0.9-1.4,1.7-1.2 c0.8,0.1,1.4,0.9,1.2,1.7l-3.3,18.4C27,26.4,26.4,26.9,25.6,26.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33.8,45.4H10.5C9.7,45.4,9,44.8,9,44c-0.3-5.4,3.5-12.2,3.7-12.5c0.4-0.7,1.3-1,2-0.6c0.7,0.4,1,1.3,0.6,2 c0,0.1-2.9,5.1-3.3,9.5h21.8c0.8,0,1.5,0.7,1.5,1.5S34.6,45.4,33.8,45.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M83.6,56.3H1.5c-0.8,0-1.5-0.7-1.5-1.5c0-5.3,3.1-6.8,4.8-6.9l75.5,0c0,0,0,0,0.1,0c1.7,0.1,4.8,1.6,4.8,6.9 C85.1,55.6,84.4,56.3,83.6,56.3z M3.1,53.3H82c-0.4-2.1-1.5-2.3-1.8-2.4H4.9C4.8,50.9,3.5,51.1,3.1,53.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBautechniker);
export default __webpack_public_path__ + "static/media/Bautechniker.06013ee972f416983fc38775fc506aee.svg";
export { ForwardRef as ReactComponent };